// Q&A for portfolio – neutral, matter-of-fact tone
export const chatBotData = {
  botName: 'Q&A',
  greeting: "Ask about Rasheed's work or background. For example: who he is, projects, contact, or experience.",
  fallback: "I don't have an answer for that. You can try: who is Rasheed, projects, contact, experience, or skills.",
  questions: [
    {
      triggers: ['who', 'rasheed', 'about', 'tell me', 'introduce', 'hello', 'hi', 'hey'],
      answer: "Rasheed Abu Khader. Software Engineer and Program Coordinator. BSc in Systems Engineering. Focus: mobile solutions and tech initiatives."
    },
    {
      triggers: ['skill', 'skills', 'what can', 'expertise', 'technologies', 'tech stack'],
      answer: "Mobile (React Native, Flutter), web frontend and backend, program coordination, tech training, JavaScript, business architecture. Emphasis on clean architecture and scalable solutions."
    },
    {
      triggers: ['project', 'projects', 'portfolio', 'built', 'work', 'apps', 'applications'],
      answer: "QuizPlus (mobile app for students), Tafawaq (education platform), Water Distribution Management (AI + sensors), Emergency Call app, Nursery Management (AI cry detection), JSOOR (crowdfunding with AI)."
    },
    {
      triggers: ['contact', 'email', 'reach', 'how to', 'get in touch', 'hire', 'message'],
      answer: "Email: rasheedabukhader123@gmail.com. WhatsApp: +972592844743. Messenger and contact form on this page (Contact section)."
    },
    {
      triggers: ['experience', 'job', 'career', 'worked', 'companies', 'roles'],
      answer: "Mobile Developer at QuizPlus (2 years), Program Coordinator at Gaza Sky Geeks (1 year), JavaScript trainer, software dev internships, IEEE Vice Chair and Treasurer."
    },
    {
      triggers: ['service', 'services', 'offer', 'freelance', 'hire him', 'what does he do'],
      answer: "Software engineering (mobile and web), program coordination and training, business consulting, freelancing, business architecture, computer engineering."
    },
    {
      triggers: ['github', 'linkedin', 'social', 'links', 'profile'],
      answer: "LinkedIn, GitHub, Instagram, Facebook, Twitter. Links are in the hero section at the top."
    },
    {
      triggers: ['education', 'degree', 'university', 'graduate', 'studied'],
      answer: "BSc in Systems Engineering (Computer Engineering). Also involved in tech education as trainer and program coordinator."
    },
    {
      triggers: ['thanks', 'thank you', 'helpful', 'bye', 'goodbye'],
      answer: "No problem. Take a look around the rest of the site if you like."
    }
  ]
};

export function getBotResponse(userMessage) {
  if (!userMessage || !userMessage.trim()) return chatBotData.greeting;
  const lower = userMessage.toLowerCase().trim();
  for (const q of chatBotData.questions) {
    if (q.triggers.some(t => lower.includes(t))) return q.answer;
  }
  return chatBotData.fallback;
}
